import { AfterContentInit, Component, ContentChildren, QueryList, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { TabController } from '../tab/tab-controller';
import { TabViewItemComponent } from '../tab-view-item/tab-view-item.component';

@Component({
  selector: 'ui-tab-view',
  templateUrl: './tab-view.component.html',
  providers: []
})
export class TabViewComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(TabViewItemComponent) tabViewItems: QueryList<TabViewItemComponent>;

  private subs: Array<Subscription> = [];

  constructor(private tabService: TabController) {
  }

  ngAfterContentInit() {
    // è®¢étabåæ¢äºä»¶ï¼å¦æåçåæ¢ï¼æ¾ç¤º/éèå¯¹åºè§å¾
    this.subs.push(this.tabService.tabIndex.subscribe((index: number) => {
      this.tabViewItems.forEach((item: TabViewItemComponent, i: number) => {
        item.active = i === index;
      });
    }));
    // åå§åæ¶ï¼é»è®¤ä¸ºç¬¬ä¸é¡¹
    const items = this.tabViewItems.toArray();
    if (items[0]) {
      items[0].active = true;
    }
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe());
  }
}